import { API_URL_SSO_LOGOUT } from 'constants/api'
import { API_USER } from 'constants/api-v2'
import { SSO_RETURN_URL_KEY } from 'constants/sso'
import { TOKEN_NAME } from 'constants/token'
import type { Profile } from 'containers/Admin/Profiles/types'
import type QueryClient from 'services/query'
import SettingsSingleton from 'services/SettingsSingleton'

interface User {
  profiles: Profile[]
  permissions: string[]
}

export const loadUser = (client: QueryClient) => async (): Promise<User | undefined> => {
  let user
  const settings = await SettingsSingleton.getInstance().getSettings(client)
  try {
    user = await client.request(API_USER)
  } catch (e: any) {
    if (e?.response?.status === 401) {
      window.localStorage.removeItem(TOKEN_NAME)
      if (settings?.ssoEnabled) {
        if (typeof window !== 'undefined') {
          const { pathname, search, hash } = window.location
          const intendedUrl = `${pathname}${search}${hash}`
          if (pathname !== '/sso' && intendedUrl) {
            // Persist the requested route before we redirect to the IdP.
            // The user loader is invoked for every protected route, so it is the
            // safest place to capture deep links when the API answers 401.
            // This complements the AuthProvider guard and covers navigation
            // directly to private URLs when no token is present.
            window.sessionStorage.setItem(SSO_RETURN_URL_KEY, intendedUrl)
          }
        }
        window.location.replace(API_URL_SSO_LOGOUT)
      } else {
        window.location.href = `/${client.locale}/login`
      }
    }
    if (e.response) throw e.response
  }

  return user
}
